import { Component, OnInit, Renderer2  } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Toaster } from 'ngx-toast-notifications';
import { OnboardingService } from 'src/app/account/auth/services/onboarding.service';
import { ModalService } from '../services/modal.service';
import { ClipboardService } from 'ngx-clipboard';
import { CardtypeService } from '../services/cardtype.service';
import { Observable, Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-checkoutmodal',
  templateUrl: './checkoutmodal.component.html',
  styleUrls: ['./checkoutmodal.component.scss']
})
export class CheckoutmodalComponent implements OnInit {

  cardForm: FormGroup;
  ussdForm: FormGroup;
  transferForm: FormGroup;
  otpForm: FormGroup;

  transferCheck: boolean;
  ussdCheck: boolean;
  cardCheck = true;

  otherDetails = true;
  cardFirstView = true;
  cardSecondView = false;
  ussdFirstView = false;
  ussdSecondView = false;
  transferFirstView = false;
  transferSecondView = false;
  confirmingTransactionView = false;
  successView = false;
  referenceDetails: any;
  transferAccountDetails: any;
  paymentRefToSend: any;
  displayTimeNgn = 300;
  timerNgn$!: Observable<number>;
  timerSubscriptionNgn!: Subscription;
  sendType = 'Card';

  bankList = [
    {
      BankName: 'Globus Bank',
      BankCode: '989'
    },
    {
      BankName: 'Rubies (Highstreet) MFB',
      BankCode: '7797'
    },
    {
      BankName: 'VFD MFB',
      BankCode: '5037'
    },
    {
      BankName: 'Union Bank',
      BankCode: '826'
    },
    {
      BankName: 'Heritage Bank',
      BankCode: '745'
    },
    {
      BankName: 'FCMB',
      BankCode: '329'
    },
    {
      BankName: 'Access (Diamond ) Bank',
      BankCode: '426'
    },
    {
      BankName: 'Access Bank',
      BankCode: '901'
    },
    {
      BankName: 'Wema Bank',
      BankCode: '945'
    },
    {
      BankName: 'Eco Bank',
      BankCode: '326'
    },
    {
      BankName: 'Keystone Bank',
      BankCode: '7111'
    },
    {
      BankName: 'Fidelity Bank',
      BankCode: '770'
    },
    {
      BankName: 'Unity Bank',
      BankCode: '7799'
    },
    {
      BankName: 'GTB',
      BankCode: '737'
    },
    {
      BankName: 'First Bank',
      BankCode: '894'
    },
    {
      BankName: 'Zenith Bank',
      BankCode: '966'
    },
    {
      BankName: 'UBA',
      BankCode: '919'
    },
    {
      BankName: 'Stanbic Bank',
      BankCode: '909'
    },
    {
      BankName: 'Sterling Bank',
      BankCode: '822'
    }
  ];
  ussdAccountDetails: any;
  ussdBankInfo: { BankName: string; BankCode: string; };
  cardType: string;
  allCardDetails: any;
  otpPinMessage: any;
  userAgent: string;
  isJavaEnabled: boolean;
  ismyTextFieldType: boolean;
  showTopAll = true;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private toaster: Toaster,
    private onboardingService: OnboardingService,
    private route: ActivatedRoute,
    private modalService: ModalService,
    private clipBoard: ClipboardService,
    private renderer: Renderer2,
    private router: Router,
    private cardTypeService: CardtypeService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.cardForm = this.formBuilder.group({
      cardNo: [ '', [ Validators.required, Validators.pattern('^[0-9]*$')]],
      expireDate: [ '', [ Validators.required, Validators.pattern('^[0-9/]*$')]],
      cvv: [ '', [ Validators.required, Validators.pattern('^[0-9]*$')]],
      cardPin: [ '', [ Validators.required, Validators.pattern('^[0-9]*$')]],
      customerName: [ '', Validators.required],
    });
    this.otpForm = this.formBuilder.group({
      otp1: ['', [Validators.required, Validators.pattern(/^[0-9]*$/)]],
      otp2: ['', [Validators.required, Validators.pattern(/^[0-9]*$/)]],
      otp3: ['', [Validators.required, Validators.pattern(/^[0-9]*$/)]],
      otp4: ['', [Validators.required, Validators.pattern(/^[0-9]*$/)]],
      otp5: ['', [Validators.required, Validators.pattern(/^[0-9]*$/)]],
      otp6: ['', [Validators.required, Validators.pattern(/^[0-9]*$/)]],
    });

    this.ussdForm = this.formBuilder.group({
      bank: [ '', Validators.required],
      customerName: [ '', Validators.required],
    });
    this.transferForm = this.formBuilder.group({
      customerName: [ '', Validators.required],
      bank: [ '', Validators.required],
    });

    await this.getUrlInformation();

  }

  togglePasswordFieldTyped() {
    this.ismyTextFieldType = !this.ismyTextFieldType;
  }

  async getUrlInformation(): Promise<void>{
    this.spinner.show();
    this.route.queryParams.subscribe(async params => {
      this.paymentRefToSend = params.paymentReference;

      await this.modalService.getReferenceDetails(this.paymentRefToSend).toPromise().then((result: any) => {
        if (result.isSuccessful) {
          this.spinner.hide();
          this.referenceDetails = result.data;
        } else {
          this.spinner.hide();
          this.toaster.open({ text: result.responseMessage || result.message, caption: 'Merchant Reference', type: 'danger' });
        }
      }, err => {
        this.spinner.hide();
        this.toaster.open({ text: err.error.responseMessage || err.error.message, caption: 'Merchant Reference', type: 'danger' });
      });

    });
  }

  async check(val: any): Promise<void>{
    if (val === 'card') {
      this.cardFirstView = true;
      this.cardSecondView = false;
      this.ussdFirstView = false;
      this.ussdSecondView = false;
      this.transferFirstView = false;
      this.transferSecondView = false;
      this.sendType = 'Card';
      this.timerSubscriptionNgn.unsubscribe();
      this.displayTimeNgn = 300;
    } else if (val === 'ussd') {
      this.cardFirstView = false;
      this.cardSecondView = false;
      this.ussdFirstView = true;
      this.ussdSecondView = false;
      this.transferFirstView = false;
      this.transferSecondView = false;
      this.sendType = 'USSD';
      this.timerSubscriptionNgn.unsubscribe();
      this.displayTimeNgn = 300;
    } else {
      this.cardFirstView = false;
      this.cardSecondView = false;
      this.ussdFirstView = false;
      this.ussdSecondView = false;
      this.transferFirstView = true;
      this.transferSecondView = false;
      this.sendType = 'Transfer';
      this.timerSubscriptionNgn.unsubscribe();
      this.displayTimeNgn = 300;
    }
  }

  getCardType(): void{
    this.cardType = this.cardTypeService.detectCardType(this.cardForm.value.cardNo);
    console.log('card', this.cardType);
  }

  checkJavaScriptEnabled(): boolean {
    try {
      return true;
    } catch (error) {
      return false;
    }
  }

  checkJavaEnabled(): void {
    try {
      const applet = document.createElement('applet') as HTMLElement;
      applet.setAttribute('width', '1');
      applet.setAttribute('height', '1');
      document.body.appendChild(applet);
      this.isJavaEnabled = true;
      document.body.removeChild(applet);
    } catch (error) {
      this.isJavaEnabled = false;
    }
  }

  async proceed1(val: any): Promise<void>{
    if (val === 'card') {
      if (this.cardType === 'Unknown') {
        this.spinner.show();
        const payload = {
          customerId: this.referenceDetails.email,
          pan: this.cardForm.value.cardNo,
          pin: this.cardForm.value.cardPin,
          expiryDate: this.cardForm.value.expireDate,
          cvv: this.cardForm.value.cvv,
          amount: this.referenceDetails.amount.toString(),
          narration: this.referenceDetails.narration,
          redirectUrl: 'https://sandbox-apigateway.myspen.com/spen-hooks/api/v1/webhook/visa-postback ',
          nameOnCard: this.cardForm.value.customerName,
          cardScheme: 'Verve',
          paymentReference: this.referenceDetails.transactionReference,
          isCheckout: true
        };
        // tslint:disable-next-line:max-line-length
        await this.modalService.getPaymentAccountCardMasterAndVerve(this.referenceDetails.merchantId, payload).toPromise().then((result: any) => {
          if (result.isSuccessful) {
            this.spinner.hide();

            if (result.provider === 'isw') {
              if (result.requires3DS === true){
                this.allCardDetails = result;
                this.modalService.setValue(this.allCardDetails);
                this.modalService.closeModal();
                // this.router.navigateByUrl('account/visa-card-payment-confirm');
              } else {
                if (result.responseCode === 'T00') {
                  this.cardFirstView = false;
                  this.cardSecondView = true;
                  this.allCardDetails = result;
                  this.otpPinMessage = result.responseMessage;
                } else if (result.responseCode === '000') {
                  this.toaster.open({ text: 'Please confirm transaction !!', caption: 'Card', type: 'success' });
                } else {
                  this.toaster.open({ text: result.responseMessage || result.message, caption: 'Card', type: 'dark' });
                }
              }
            } else if (result.provider === 'payaza') {
              if (result.requires3DS === true){
                this.allCardDetails = result;
                this.modalService.setValue(this.allCardDetails);
                this.modalService.closeModal();
                // this.router.navigateByUrl('account/visa-card-payment-confirm2');
              } else {
                this.cardFirstView = false;
                this.cardSecondView = true;
                this.allCardDetails = result;
                this.otpPinMessage = result.responseMessage;
              }
            }

            // if (result.responseCode === 'T00'){
            //   this.cardFirstView = false;
            //   this.cardSecondView = true;
            //   this.allCardDetails = result;
            //   this.otpPinMessage = result.responseMessage;
            // } else if (result.responseCode === 'S00') {
            //   this.allCardDetails = result;
            //   this.modalService.setValue(this.allCardDetails);
            //   this.modalService.closeModal();
            //   this.router.navigateByUrl('account/visa-card-payment-confirm');
            // } else {
            //   this.spinner.hide();
            //   this.toaster.open({ text: result.responseMessage || result.message, caption: 'Card', type: 'danger' });
            // }

          } else {
            this.spinner.hide();
            this.toaster.open({ text: result.responseMessage || result.message, caption: 'Card', type: 'danger' });
          }
        }, err => {
          this.spinner.hide();
          this.toaster.open({ text: err.error.responseMessage || err.error.message, caption: 'Card', type: 'danger' });
        });
      } else if (this.cardType === 'MasterCard' || this.cardType === 'Verve') {
        this.spinner.show();
        const payload = {
          customerId: this.referenceDetails.email,
          pan: this.cardForm.value.cardNo,
          pin: this.cardForm.value.cardPin,
          expiryDate: this.cardForm.value.expireDate,
          cvv: this.cardForm.value.cvv,
          amount: this.referenceDetails.amount.toString(),
          narration: this.referenceDetails.narration,
          redirectUrl: 'https://sandbox-apigateway.myspen.com/spen-hooks/api/v1/webhook/visa-postback ',
          nameOnCard: this.cardForm.value.customerName,
          cardScheme: this.cardType,
          paymentReference: this.referenceDetails.transactionReference,
          isCheckout: true
        };
        // tslint:disable-next-line:max-line-length
        await this.modalService.getPaymentAccountCardMasterAndVerve(this.referenceDetails.merchantId, payload).toPromise().then((result: any) => {
          if (result.isSuccessful) {
            this.spinner.hide();

            if (result.provider === 'isw') {
              if (result.requires3DS === true){
                this.allCardDetails = result;
                this.modalService.setValue(this.allCardDetails);
                this.modalService.closeModal();
                // this.router.navigateByUrl('account/visa-card-payment-confirm');
              } else {
                if (result.responseCode === 'T00') {
                  this.cardFirstView = false;
                  this.cardSecondView = true;
                  this.allCardDetails = result;
                  this.otpPinMessage = result.responseMessage;
                } else if (result.responseCode === '000') {
                  this.toaster.open({ text: 'Please confirm transaction !!', caption: 'Card', type: 'success' });
                } else {
                  this.toaster.open({ text: result.responseMessage || result.message, caption: 'Card', type: 'dark' });
                }
              }
            } else if (result.provider === 'payaza') {
              if (result.requires3DS === true){
                this.allCardDetails = result;
                this.modalService.setValue(this.allCardDetails);
                this.modalService.closeModal();
                // this.router.navigateByUrl('account/visa-card-payment-confirm2');
              } else {
                this.cardFirstView = false;
                this.cardSecondView = true;
                this.allCardDetails = result;
                this.otpPinMessage = result.responseMessage;
              }
            }

            // if (result.responseCode === 'T00'){
            //   this.cardFirstView = false;
            //   this.cardSecondView = true;
            //   this.allCardDetails = result;
            //   this.otpPinMessage = result.responseMessage;
            // } else if (result.responseCode === 'S00') {
            //   this.allCardDetails = result;
            //   this.modalService.setValue(this.allCardDetails);
            //   this.modalService.closeModal();
            //   this.router.navigateByUrl('account/visa-card-payment-confirm');
            // } else {
            //   this.spinner.hide();
            //   this.toaster.open({ text: result.responseMessage || result.message, caption: 'Card', type: 'danger' });
            // }

          } else {
            this.spinner.hide();
            this.toaster.open({ text: result.responseMessage || result.message, caption: 'Card', type: 'danger' });
          }
        }, err => {
          this.spinner.hide();
          this.toaster.open({ text: err.error.responseMessage || err.error.message, caption: 'Card', type: 'danger' });
        });
      }  else if (this.cardType === 'Visa') {
        // Get the user agent value
        const userAgent = navigator.userAgent;
        // Get Javascript Enabled
        const isJavaScriptEnabled = this.checkJavaScriptEnabled();
        // Get Java Enabled
        this.checkJavaEnabled();
        this.spinner.show();
        const payload = {
          customerId: this.referenceDetails.email,
          pan: this.cardForm.value.cardNo,
          // pin: this.cardForm.value.cardPin,
          expiryDate: this.cardForm.value.expireDate,
          cvv: this.cardForm.value.cvv,
          amount: this.referenceDetails.amount.toString(),
          narration: this.referenceDetails.narration,
          redirectUrl: 'https://sandbox-apigateway.myspen.com/spen-hooks/api/v1/webhook/visa-postback ',
          nameOnCard: this.cardForm.value.customerName,
          cardScheme: this.cardType,
          paymentReference: this.referenceDetails.transactionReference,
          isCheckout: true,
          deviceInformation: {
            httpBrowserLanguage: 'en-US',
            httpBrowserJavaEnabled: this.isJavaEnabled,
            httpBrowserJavaScriptEnabled: isJavaScriptEnabled,
            httpBrowserColorDepth: 24,
            httpBrowserScreenHeight: 820,
            httpBrowserScreenWidth: 360,
            httpBrowserTimeDifference: '',
            userAgentBrowserValue: userAgent,
            deviceChannel: 'Browser'
          }
        };
        // tslint:disable-next-line:max-line-length
        await this.modalService.getPaymentAccountCardMasterAndVerve(this.referenceDetails.merchantId, payload).toPromise().then((result: any) => {
          if (result.isSuccessful) {
            this.spinner.hide();

            if (result.provider === 'isw') {
              if (result.requires3DS === true){
                this.allCardDetails = result;
                this.modalService.setValue(this.allCardDetails);
                this.modalService.closeModal();
                this.router.navigateByUrl('account/visa-card-payment-confirm');
              } else {
                if (result.responseCode === 'T00') {
                  this.cardFirstView = false;
                  this.cardSecondView = true;
                  this.allCardDetails = result;
                  this.otpPinMessage = result.responseMessage;
                } else if (result.responseCode === '000') {
                  this.toaster.open({ text: 'Please confirm transaction !!', caption: 'Card', type: 'success' });
                } else {
                  this.toaster.open({ text: result.responseMessage || result.message, caption: 'Card', type: 'dark' });
                }
              }
            } else if (result.provider === 'payaza') {
              if (result.requires3DS === true){
                this.allCardDetails = result;
                this.modalService.setValue(this.allCardDetails);
                this.modalService.closeModal();
                this.router.navigateByUrl('account/visa-card-payment-confirm2');
              } else {
                this.cardFirstView = false;
                this.cardSecondView = true;
                this.allCardDetails = result;
                this.otpPinMessage = result.responseMessage;
              }
            }

            // if (result.responseCode === 'T00'){
            //   this.cardFirstView = false;
            //   this.cardSecondView = true;
            //   this.allCardDetails = result;
            //   this.otpPinMessage = result.responseMessage;
            // } else if (result.responseCode === 'S00') {
            //   this.allCardDetails = result;
            //   this.modalService.setValue(this.allCardDetails);
            //   this.modalService.closeModal();
            //   this.router.navigateByUrl('account/visa-card-payment-confirm');
            // } else {
            //   this.spinner.hide();
            //   this.toaster.open({ text: result.responseMessage || result.message, caption: 'Card', type: 'danger' });
            // }

          } else {
            this.spinner.hide();
            this.toaster.open({ text: result.responseMessage || result.message, caption: 'Card', type: 'danger' });
          }
        }, err => {
          this.spinner.hide();
          this.toaster.open({ text: err.error.responseMessage || err.error.message, caption: 'Card', type: 'danger' });
        });
      } else {
        this.toaster.open({ text: 'Not a valid card number', caption: 'Card', type: 'danger' });
      }
    } else if (val === 'ussd') {
      this.spinner.show();
      const bankAll = this.bankList.find(x => x.BankCode === this.ussdForm.value.bank);
      this.ussdBankInfo = bankAll;
      const payload = {
        paymentReference: this.paymentRefToSend,
        channel: 'virtual_account',
        customerName: this.ussdForm.value.customerName,
        bankCode: this.ussdForm.value.bank
      };
      await this.modalService.getPaymentAccountUssd(this.referenceDetails.merchantId, payload).toPromise().then((result: any) => {
        if (result.isSuccessful) {
          this.startTimerNgn();
          this.spinner.hide();
          this.ussdAccountDetails = result.data;
          this.ussdFirstView = false;
          this.ussdSecondView = true;
        } else {
          this.spinner.hide();
          this.toaster.open({ text: result.responseMessage || result.message, caption: 'Transfer', type: 'danger' });
        }
      }, err => {
        this.spinner.hide();
        this.toaster.open({ text: err.error.responseMessage || err.error.message, caption: 'Transfer', type: 'danger' });
      });
    } else {
      this.spinner.show();
      const payload = {
        paymentReference: this.paymentRefToSend,
        channel: 'virtual_account',
        customerName: this.transferForm.value.customerName
      };
      await this.modalService.getPaymentAccountTransfer(this.referenceDetails.merchantId, payload).toPromise().then((result: any) => {
        if (result.isSuccessful) {
          this.startTimerNgn();
          this.spinner.hide();
          this.transferAccountDetails = result.data;
          this.transferFirstView = false;
          this.transferSecondView = true;
        } else {
          this.spinner.hide();
          this.toaster.open({ text: result.responseMessage || result.message, caption: 'Transfer', type: 'danger' });
        }
      }, err => {
        this.spinner.hide();
        this.toaster.open({ text: err.error.responseMessage || err.error.message, caption: 'Transfer', type: 'danger' });
      });
    }
  }

  async proceed2(val: any): Promise<void>{
    if (val === 'card') {
      this.otherDetails = false;
      this.cardFirstView = false;
      this.cardSecondView = false;
      this.ussdFirstView = false;
      this.ussdSecondView = false;
      this.transferFirstView = false;
      this.transferSecondView = false;
      this.showTopAll = false;
      this.confirmingTransactionView = true;
      const payload = {
        transactionReference: this.allCardDetails.transactionReference,
        otp: `${this.otpForm.value.otp1}${this.otpForm.value.otp2}${this.otpForm.value.otp3}${this.otpForm.value.otp4}${this.otpForm.value.otp5}${this.otpForm.value.otp6}`
      };
      await this.modalService.validateCardPaymentOtp(payload).toPromise().then((result: any) => {
        if (result.isSuccessful) {
          this.otherDetails = false;
          this.cardFirstView = false;
          this.cardSecondView = false;
          this.confirmingTransactionView = false;
          this.successView = true;
        } else {
          this.showTopAll = true;
          this.otherDetails = true;
          this.cardFirstView = false;
          this.cardSecondView = true;
          this.ussdFirstView = false;
          this.ussdSecondView = false;
          this.transferFirstView = false;
          this.transferSecondView = false;
          this.confirmingTransactionView = false;
          this.transferCheck = false;
          this.ussdCheck = false;
          this.cardCheck = true;
          this.toaster.open({ text: result.responseMessage || result.message, caption: 'OTP', type: 'danger' });
        }
      }, err => {
        this.showTopAll = true;
        this.otherDetails = true;
        this.cardFirstView = false;
        this.cardSecondView = true;
        this.ussdFirstView = false;
        this.ussdSecondView = false;
        this.transferFirstView = false;
        this.transferSecondView = false;
        this.confirmingTransactionView = false;
        this.transferCheck = false;
        this.ussdCheck = false;
        this.cardCheck = true;
        this.toaster.open({ text: err.error.responseMessage || err.error.message, caption: 'OTP', type: 'danger' });
      });
    } else if (val === 'ussd') {
      this.otherDetails = false;
      this.cardFirstView = false;
      this.cardSecondView = false;
      this.ussdFirstView = false;
      this.ussdSecondView = false;
      this.transferFirstView = false;
      this.transferSecondView = false;
      this.showTopAll = false;
      this.confirmingTransactionView = true;
      this.route.queryParams.subscribe(async params => {
        this.paymentRefToSend = params.paymentReference;
        await this.modalService.getReferenceDetails(this.paymentRefToSend).toPromise().then((result: any) => {
          if (result.isSuccessful) {
            if ( result.data.finalTransactionStatus === null || result.data.paymentStatus === null ) {
              this.otherDetails = true;
              this.cardFirstView = false;
              this.cardSecondView = false;
              this.ussdFirstView = false;
              this.ussdSecondView = true;
              this.transferFirstView = false;
              this.transferSecondView = false;
              this.confirmingTransactionView = false;
              this.transferCheck = false;
              this.ussdCheck = true;
              this.cardCheck = false;
              this.toaster.open({ text: 'Transaction not confirmed yet !!', caption: 'Confirm Transaction', type: 'danger' });
            } else if ( result.data.finalTransactionStatus === 'Success' || result.data.paymentStatus === 'Received') {
              this.otherDetails = false;
              this.ussdFirstView = false;
              this.ussdSecondView = false;
              this.confirmingTransactionView = false;
              this.successView = true;
            }
          } else {
            this.showTopAll = true;
            this.toaster.open({ text: result.responseMessage || result.message, caption: 'Confirm Transaction', type: 'danger' });
          }
        }, err => {
          this.showTopAll = true;
          this.toaster.open({ text: err.error.responseMessage || err.error.message, caption: 'Confirm Transaction', type: 'danger' });
        });

      });
    } else {
      this.otherDetails = false;
      this.cardFirstView = false;
      this.cardSecondView = false;
      this.ussdFirstView = false;
      this.ussdSecondView = false;
      this.transferFirstView = false;
      this.transferSecondView = false;
      this.showTopAll = false;
      this.confirmingTransactionView = true;
      this.route.queryParams.subscribe(async params => {
        this.paymentRefToSend = params.paymentReference;
        await this.modalService.getReferenceDetails(this.paymentRefToSend).toPromise().then((result: any) => {
          if (result.isSuccessful) {
            if ( result.data.finalTransactionStatus === null || result.data.paymentStatus === null ) {
              this.otherDetails = true;
              this.cardFirstView = false;
              this.cardSecondView = false;
              this.ussdFirstView = false;
              this.ussdSecondView = false;
              this.transferFirstView = false;
              this.transferSecondView = true;
              this.confirmingTransactionView = false;
              this.transferCheck = true;
              this.ussdCheck = false;
              this.cardCheck = false;
              this.toaster.open({ text: 'Transaction not confirmed yet !!', caption: 'Confirm Transaction', type: 'danger' });
              this.showTopAll = true;
            } else if ( result.data.finalTransactionStatus === 'Success' || result.data.paymentStatus === 'Received') {
              this.otherDetails = false;
              this.transferFirstView = false;
              this.transferSecondView = false;
              this.confirmingTransactionView = false;
              this.successView = true;
            }
          } else {
            this.toaster.open({ text: result.responseMessage || result.message, caption: 'Confirm Transaction', type: 'danger' });
            this.showTopAll = true;
          }
        }, err => {
          this.toaster.open({ text: err.error.responseMessage || err.error.message, caption: 'Confirm Transaction', type: 'danger' });
          this.showTopAll = true;
        });

      });
    }
  }

  copyAccNo(val: any): void{
    this.clipBoard.copy(val);
    this.toaster.open({ text: 'Account No Copied Successfully !!', caption: 'Transfer', type: 'success' });
  }

  copyUssd(val: any): void{
    this.clipBoard.copy(val);
    this.toaster.open({ text: 'USSD Code Copied Successfully !!', caption: 'USSD', type: 'success' });
  }

  doneTransfer(): void{
    window.close();
    sessionStorage.clear();
  }

  startTimerNgn() {
    this.timerNgn$ = timer(0, 1000);
    this.timerSubscriptionNgn = this.timerNgn$.subscribe(() => {
      if (this.displayTimeNgn > 0) {
        this.displayTimeNgn--;
      } else {
        // Timer has finished
        this.timerSubscriptionNgn.unsubscribe();
        this.displayTimeNgn = 300;
      }
    });
  }

  async resendCardOtp(): Promise<void> {
    this.spinner.show();
    const payload = {
      transactionReference: this.allCardDetails.transactionReference
    };
    await this.modalService.resendCardPaymentOtp(payload).toPromise().then((result: any) => {
      if (result.isSuccessful) {
        this.spinner.hide();
        this.toaster.open({ text: result.responseMessage || result.message, caption: 'OTP', type: 'success' });
      } else {
        this.spinner.hide();
        this.toaster.open({ text: result.responseMessage || result.message, caption: 'OTP', type: 'danger' });
      }
    }, err => {
      this.spinner.hide();
      this.toaster.open({ text: err.error.responseMessage || err.error.message, caption: 'OTP', type: 'danger' });
    });
  }

}
